import React, { useState} from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import { parseDate } from "utils/Utils";
import GridItem from "components/Grid/GridItem";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import BottomButton from "components/CustomButtons/BottomButtons";
import ToastModal from "views/components/ToastModal";
import { packetSizes } from "assets/properties/properties";

const PacketInventoryHistory = ({classes, featureFlagState}) => {
  const [packetNumber, setPacketNumber] = useState("");
  const [packetNumberState, setPacketNumberState] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [showData, setShowData] = useState(false);
  const [tableColumnsDate, setTableColumnsDate] = useState([
    { id: "packetNumber", label: "Packet Number" },
    { id: "size", label: "Size" },
    {id: "weight", label:"Packet Weight"},
    { id: "branchName", label: "Branch Name" },
    { id: "loanAccountNumber", label: "Loan Account Number" },
    { id: "branchCode", label: "Branch Code" },
    { id: "status", label: "Status" },
    { id: "allocatedDate", label: "Allocated Date" },
    { id: "assignDate", label: "Assign Date" },
    { id: "damageDate", label: "Damage Date" },
    { id: "allocatedBy", label: "Allocated By" },
    { id: "assignedBy", label: "Assigned By" },
  ]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
  };

  const SearchData = async () => {
    if(packetNumber){
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.PACKET_SEARCH + packetNumber,
      authToken: authToken,
    });
    setCallInProgress(false);

    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
      setShowData(false);
    } else {
      setShowData(true);
      parseIndicatorData(result?.data);
    }
  }else{
    toastUpdate("Error", "Plese provide the packet number", true);
  }
  };
    const packetSizeList = typeof featureFlagState?.packetSizesList !== "undefined" ? JSON.parse(featureFlagState?.packetSizesList) : packetSizes;
  
  const parseIndicatorData = (data) => {
    let reportData = [];
    const baseData = {
      packetNumber: data.packetNumber,
      size: packetSizeList?.[0]?.name || data.size,
      weight: data?.packetWeight,
      branchName: data.branchName,
      branchCode: data.branchCode,
      status: data.status,
      allocatedDate: parseDate(data.allocatedDate),
      damageDate: parseDate(data.damageDate),
      allocatedBy: data.allocatedBy,
    };
    if (Array.isArray(data.assignedPacketDetails) && data.assignedPacketDetails.length > 0) {
      reportData = data.assignedPacketDetails.map((item) => ({
        ...baseData,
        loanAccountNumber: item.loanAccountNumber,
        assignedBy: item.assignedBy || data.assignedBy,
        assignDate: parseDate(item.assignDate),
      }));
    } else {
      reportData.push({
        ...baseData,
        loanAccountNumber: data.loanAccountNumber,
        assignedBy: data.assignedBy,
        assignDate: parseDate(data.assignDate),
      });
    }

    setSelectedTableData(reportData);
  };

  const clearData = () => {
    setPacketNumber("");
  };
  const clearResultData = () => {
    setShowData(false);
  };
  const handleChange = (e) => {
      setPacketNumber(e);
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader label="Packet History" />
      </Grid>

      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Packet Number"
              required
              error={packetNumberState}
              id="lp_branch_code"
              value={packetNumber || ""}
              setState={handleChange}
              type="packetNumber"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <BottomButton
              button1="Search"
              button1click={SearchData}
              button2="Clear"
              button2click={clearData}
              button3="Clear Result"
              button3click={clearResultData}
            />
          </Grid>
          {showData && (
            <GridItem xs={12} sm={12} md={12}>
              <ColumnGroupingTable
                columns={tableColumnsDate}
                rows={selectedTableData}
              />
            </GridItem>
          )}
          {callInProgress && (
            <CircularProgresss callInProgress={callInProgress} />
          )}
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
        </Grid>
      </Grid>
    </Grid>
  );
};

PacketInventoryHistory.propTypes = {
  classes: PropTypes.object,
};

export default PacketInventoryHistory;
